// import { Base64 } from 'js-base64';
// import { Crypto } from 'cryptojs';
import React from 'react';
import dayjs from 'dayjs';
import Toast from '../../Toast/Toast';

const Config = {
  menus: [
    'head',
    'bold',
    'fontSize',
    // 'fontName',
    'italic',
    'underline',
    'strikeThrough',
    'indent',
    'lineHeight',
    'foreColor',
    // 'backColor',
    // 'link',
    'list',
    // 'todo',
    'justify',
    'quote',
    // 'emoticon',
    'image',
    // 'video',
    // 'table',
    // 'code',
    // 'splitLine',
    'undo',
    'redo',
    // 'ImageMenuEditor',
  ],
  fontFamily: [
    'Arial',
    '微软雅黑',
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'PingFang SC',
    'Hiragino Sans GB',
    'Microsoft YaHei',
    'Helvetica Neue',
    'Helvetica',
    'sans-serif',
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol',
  ],
  lineHeights: ['1.15', '1.6', '2', '2.5', '3'],
  validateType(file) {
    if (!file) {
      return '上传的图片有问题';
    }
    const type = (file.type && file.type.toLowerCase()) || '';
    if (type.indexOf('image') < 0) {
      return '上传的图片类型有问题';
    }
    return null;
  },
  validateSize(file) {
    if (file.size > 1024 * 1024) {
      return '上传失败：请将图片控制在1MB以内';
    }
    return null;
  },
  validatePxiel(file) {
    return new Promise(resolve => {
      const url = window.URL || window.webkitURL;
      const img = new Image();
      img.onload = () => {
        if (img.width <= 3000 || img.height <= 3000) {
          resolve(null);
        }
        resolve('上传失败：请将图片大小控制在3000像素以内');
      };
      img.onerror = () => {
        resolve('上传失败：图片有问题');
      };
      img.src = url.createObjectURL(file);
    });
  },
  async validate(file) {
    const type = Config.validateType(file);
    const size = Config.validateSize(file);
    const pxiel = await Config.validatePxiel(file);
    // 验证不通过
    if (type || size || pxiel) {
      Toast.error({
        content: type || size || pxiel,
      });
      return false;
    }
    return true;
  },
  getUploadParams({ accessKeyId, policy, signature, dir, expire, file }) {
    const suffix = file.name.slice(file.name.lastIndexOf('.') + 1);
    const filename = `${Math.random() * 10000}-${dayjs().format(
      'YYYY-MM-DD',
    )}-${Date.now()}-${suffix}`;
    return {
      name: filename,
      key: `${dir}${filename}`, // g_object_name表示上传后的文件路径。如果您希望上传后保持原来的文件名，请将该字段改为’key’: '${filename}'
      policy,
      OSSAccessKeyId: accessKeyId,
      success_action_status: 200, // 让服务端返回200,不然，默认会返回204
      Signature: signature,
      signature,
      expire: +expire,
      'x-oss-tagging': 'inUse=false',
    };
  },
};

export default Config;
